<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="square" stroke-linejoin="miter" aria-hidden="true">
    <line x1="21" y1="12" x2="5" y2="12"/>
    <polyline points="11,5 4,12 11,19"/>
  </svg>
</template>
